import React from 'react';
import { Button, ButtonProps } from '@chakra-ui/react';

import { InputProps, useFileInput } from './useFileInput';

type Props = ButtonProps & {
  onFileSelect: (files: Array<File>) => void;
  inputProps?: InputProps;
};

export function FilePickerButton(props: Props) {
  const { onFileSelect, inputProps, ...otherProps } = props;
  const [inputId] = useFileInput({ onFileSelect, inputProps });
  return (
    <Button
      {...otherProps}
      as="label"
      role="button"
      cursor="pointer"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === ' ' || event.key === 'Enter') {
          event.preventDefault();
          (event.target as HTMLLabelElement).click();
        }
      }}
      htmlFor={inputId}
    />
  );
}
